import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const round = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const load6 = (props: IDotLoaderProps) => keyframes`
  0% {
    box-shadow: 0 ${-0.83 * props.width}px 0 ${-0.4 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.42 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.44 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.46 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.477 * props.width}px;
  }
  5%,
  95% {
    box-shadow: 0 ${-0.83 * props.width}px 0 ${-0.4 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.42 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.44 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.46 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.477 * props.width}px;
  }
  10%,
  59% {
    box-shadow: 0 ${-0.83 * props.width}px 0 ${-0.4 * props.width}px, ${-0.087 * props.width}px ${-0.825 * props.width}px 0 ${-0.42 * props.width}px, ${-0.173 * props.width}px ${-0.812 * props.width}px 0 ${-0.44 * props.width}px, ${-0.256 * props.width}px ${-0.789 * props.width}px 0 ${-0.46 * props.width}px, ${-0.297 * props.width}px ${-0.775 * props.width}px 0 ${-0.477 * props.width}px;
  }
  20% {
    box-shadow: 0 ${-0.83 * props.width}px 0 ${-0.4 * props.width}px, ${-0.338 * props.width}px ${-0.758 * props.width}px 0 ${-0.42 * props.width}px, ${-0.555 * props.width}px ${-0.617 * props.width}px 0 ${-0.44 * props.width}px, ${-0.671 * props.width}px ${-0.488 * props.width}px 0 ${-0.46 * props.width}px, ${-0.749 * props.width}px ${-0.34 * props.width}px 0 ${-0.477 * props.width}px;
  }
  38% {
    box-shadow: 0 ${-0.83 * props.width}px 0 ${-0.4 * props.width}px, ${-0.377 * props.width}px ${-0.74 * props.width}px 0 ${-0.42 * props.width}px, ${-0.645 * props.width}px ${-0.522 * props.width}px 0 ${-0.44 * props.width}px, ${-0.775 * props.width}px ${-0.297 * props.width}px 0 ${-0.46 * props.width}px, ${-0.82 * props.width}px ${-0.09 * props.width}px 0 ${-0.477 * props.width}px;
  }
  100% {
    box-shadow: 0 ${-0.83 * props.width}px 0 ${-0.4 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.42 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.44 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.46 * props.width}px, 0 ${-0.83 * props.width}px 0 ${-0.477 * props.width}px;
  }
`;

interface IDotLoaderProps {
  height?: number;
  width?: number;
  color?: string;
}

const LoaderWrapper = styled.div`
  width: ${(props: IDotLoaderProps) => props.width}px;
  height: ${(props: IDotLoaderProps) => props.height}px;
`;

const Loader = styled.div`
  font-size: 90px;
  width: ${(props: IDotLoaderProps) => props.width}px;
  height: ${(props: IDotLoaderProps) => props.width}px;
  color: ${(props: IDotLoaderProps) => props.color};
  text-indent: -9999em;
  overflow: hidden;
  border-radius: 50%;
  margin: 72px auto;
  position: relative;
  transform: translateZ(0);
  animation: ${(props: IDotLoaderProps) => load6(props)} 1.7s infinite ease, ${round} 1.7s infinite ease;
`;
export const FadeOutSpinner = (props: { height: number; width: number; color: string; style?: React.CSSProperties;  }) => {
  return (
    <LoaderWrapper
      width={props.width}
      height={props.height}
      style={props.style}
    >
      <Loader
        width={props.width / 2.5}
        color={props.color}
      />
    </LoaderWrapper>
  );
};